import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Separator } from '../ui/separator';
import { FileText, Printer } from 'lucide-react';
import { formatChileanDate, dateToChileanString, getCurrentChileanDate } from '../../utils/dateUtils';

export const VacationVoucher = ({ request, className = '' }) => {
  const handlePrint = () => {
    const printContent = document.getElementById(`voucher-${request.id}`);
    if (printContent) {
      const originalContent = document.body.innerHTML;
      document.body.innerHTML = printContent.innerHTML;
      window.print();
      document.body.innerHTML = originalContent;
      window.location.reload();
    }
  };
  
  const formatDate = (dateString) => formatChileanDate(dateString);
  
  const getTypeLabel = (type) => {
    switch (type) {
      case 'full': return 'Días Completos';
      case 'half': return 'Medios Días';
      case 'administrative': return 'Días Administrativos';
      default: return type;
    }
  };
  
  return (
    <div className={className}>
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-lg font-semibold flex items-center gap-2">
          <FileText size={20} />
          Comprobante de Solicitud de Vacaciones
        </h3>
        <Button onClick={handlePrint} variant="outline" size="sm" className="flex items-center gap-2">
          <Printer size={16} />
          Imprimir
        </Button>
      </div>
      
      <Card id={`voucher-${request.id}`} className="print:shadow-none">
        <CardHeader className="text-center border-b">
          <CardTitle className="text-xl">SOLICITUD DE VACACIONES</CardTitle>
          <p className="text-sm text-muted-foreground">Comprobante N° {request.id}</p>
        </CardHeader>
        
        <CardContent className="space-y-6 p-6">
          <div className="grid grid-cols-2 gap-6">
            <div>
              <h4 className="font-semibold mb-3">Datos del Empleado</h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="font-medium">Nombre:</span>
                  <span>{request.employeeName}</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Fecha Solicitud:</span>
                  <span>{formatDate(request.requestDate)}</span>
                </div>
              </div>
            </div>
            
            <div>
              <h4 className="font-semibold mb-3">Período Solicitado</h4>
              <div className="space-y-2 text-sm">
                <div className="flex justify-between">
                  <span className="font-medium">Desde:</span>
                  <span>{formatDate(request.startDate)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Hasta:</span>
                  <span>{formatDate(request.endDate)}</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Total Días:</span>
                  <span className="font-semibold">{request.totalDays} días</span>
                </div>
                <div className="flex justify-between">
                  <span className="font-medium">Tipo:</span>
                  <span>{getTypeLabel(request.type)}</span>
                </div>
              </div>
            </div>
          </div>
          
          {request.notes && (
            <div>
              <h4 className="font-semibold mb-2">Observaciones</h4>
              <p className="text-sm bg-muted p-3 rounded">{request.notes}</p>
            </div>
          )}
          
          <Separator />
          
          <div className="grid grid-cols-2 gap-8 pt-8">
            <div className="text-center">
              <div className="border-t border-gray-400 pt-2">
                <p className="text-sm font-medium">Firma del Empleado</p>
                <p className="text-xs text-muted-foreground mt-1">{request.employeeName}</p>
              </div>
            </div>
            
            <div className="text-center">
              <div className="border-t border-gray-400 pt-2">
                <p className="text-sm font-medium">Firma y Timbre Jefatura</p>
                <p className="text-xs text-muted-foreground mt-1">Autorización</p>
              </div>
            </div>
          </div>
          
          <div className="text-center pt-4">
            <p className="text-xs text-muted-foreground">
              Fecha de emisión: {formatChileanDate(dateToChileanString(getCurrentChileanDate()))}
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
